import { cn } from "cy-fe/src/utils/cn";
import { ReactNode, useId } from "react";

export function Tab<T extends string>({
  className,
  children,
}: {
  selectedTab: T;
  className?: string;
  onChange?: (tab: T) => void;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "text-default grid grid-cols-2 gap-2 rounded bg-gray-100 px-3 py-1 text-sm font-normal sm:max-w-[32rem]",
        "mx-2 sm:mx-auto",
        className,
      )}
    >
      {children}
    </div>
  );
}
export function TabButton<T extends string>({
  children,
  selected,
  onchange,
  value,
}: {
  children: ReactNode;
  value: T;
  selected?: boolean;
  onchange?: (tab: T) => void;
}) {
  const id = useId();
  return (
    <button
      tabIndex={0}
      type="button"
      onClick={() => onchange?.(value)}
      className={cn(
        "relative block rounded border-0 py-[0.4rem] text-center hover:cursor-pointer",
        selected && "text-default bg-white shadow",
        !selected && "text-default/75",
        "ring-color-form-outline",
        "hover:ring-w-form-hover",
      )}
    >
      <input
        id={id}
        type="radio"
        tabIndex={-1}
        className="sr-only select-none"
        name="tab"
        value={value}
        checked={selected}
        onChange={(e) => onchange?.(e.target.value as T)}
      />
      {children}
    </button>
  );
}
